import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

const SimilarityIdeaCardSkeleton = () => {
  return (
    <div className="flex size-full rounded-lg border bg-card text-card-foreground shadow-sm">
      <div className="flex w-full flex-col">
        {/* Header */}
        <div className="flex items-start gap-4 p-6">
          <Skeleton className="h-6 w-20 rounded" />
          <Skeleton className="h-6 flex-1" />
        </div>

        {/* Content */}
        <div className="space-y-4 px-6 pb-6">
          {/* Description */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>

          {/* Badges */}
          <div className="flex items-center gap-4">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="flex items-center gap-1">
                <Skeleton className="size-4" />
                <Skeleton className="h-4 w-8" />
              </div>
            ))}
          </div>

          <Separator className="animate-pulse bg-muted" />

          {/* Footer */}
          <div className="flex items-center justify-between gap-6">
            {/* Participants */}
            <div className="flex items-center gap-2">
              <div className="flex -space-x-2">
                {Array.from({ length: 3 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    className="size-8 rounded-full border-2 border-background"
                  />
                ))}
              </div>
            </div>

            {/* Status */}
            <Skeleton className="h-6 w-24 rounded-full" />

            {/* Similarity */}
            <Skeleton className="h-6 w-12 rounded" />
          </div>

          {/* Challenge */}
          <div className="mt-4 rounded-lg border p-3">
            <div className="flex items-center gap-2">
              <Skeleton className="size-4" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

SimilarityIdeaCardSkeleton.displayName = 'SimilarityIdeaCardSkeleton'

export { SimilarityIdeaCardSkeleton }
